/**
 * Anim to play's choices: the clips of the model an entity's `clipRef` source
 * prop (e.g. MeshRenderer.mesh) points at, from the content index's asset
 * catalog. Empty when there's no model yet, or it isn't catalogued.
 */
import type { AssetIndexEntry } from "../../assets/content";
import type { ComponentData } from "../../world/schema/defineComponent";
import type { ClipSource } from "../../world/schema/propTypes";

export function clipOptions(
  components: ReadonlyMap<string, ComponentData>,
  source: ClipSource,
  catalog: readonly AssetIndexEntry[],
): readonly string[] {
  const path = components.get(source.component)?.[source.prop];
  if (typeof path !== "string") return [];
  return catalog.find((asset) => asset.path === path)?.clips ?? [];
}
